<template>
  <div class="create">
    <template v-if="status === 1">
      <status-bar
        @close="topStatus = null"
        v-if="topStatus"
        :text="topStatus.text"
        :state="topStatus.type"
        class="status-bar"
      ></status-bar>
      <div class="form-container">
        <h3>创建工单</h3>
        <div class="line" />
        <div class="form">
          <bcc-form
            :rules="rules"
            ref="form"
            :model="form"
            @submit.native.prevent
          >
            <bcc-form-item
              class="work-order-type"
              label="工单类型"
              prop="tag_id"
              required
            >
              <bcc-select v-model="form.tag_id" width="300px">
                <bcc-option
                  v-for="item in types"
                  :label="item.label"
                  :key="item.value"
                  :value="item.value"
                ></bcc-option>
              </bcc-select>
              <div class="new-tip">
                *
                需要研发介入的问题请选择[开发问题]，和开发无关的问题请选择[产品建议]
              </div>
            </bcc-form-item>
            <bcc-form-item label="问题描述" prop="des" required>
              <bcc-input
                showWordLimit
                maxlength="200"
                v-model="form.des"
                type="textarea"
                placeholder="描述请填写涉及的接口、入参和返回参数，以及相关错误信息和配图，和发生时间。如果信息不全可能会导致工单受理超时或无法处理"
              ></bcc-input>
            </bcc-form-item>
            <bcc-form-item label="手机" prop="mobile" required>
              <bcc-input
                v-model="form.mobile"
                placeholder="请填写手机"
                maxlength="80"
              ></bcc-input>
            </bcc-form-item>
            <validator
              :value="form.email"
              name="邮箱"
              :validator="validator.email"
            >
              <bcc-form-item label="邮箱">
                <bcc-input
                  v-model="form.email"
                  placeholder="请填写邮箱"
                  maxlength="80"
                  :isError="validator.email.showError"
                ></bcc-input>
              </bcc-form-item>
            </validator>
            <bcc-form-item label="相关附件">
              <div>
                <div v-if="file" class="file-des">
                  {{ file.name }}
                  <bcc-icon type="ic_delete_" @click="handleDelete"></bcc-icon>
                </div>
              </div>
              <div class="attach-container">
                <bcc-button size="max-large" @click="selectFile"
                  >{{ file ? "修改" : "上传" }}附件</bcc-button
                >
                <div class="tip">
                  仅支持上传单个文件，且格式为 .png, .jpg, .jpeg, .log, .txt,
                  .zip, .rar，大小在 10MB 以内
                </div>
              </div>
            </bcc-form-item>
            <bcc-form-item label="复现概率">
              <bcc-radio-group v-model="form.frequency">
                <bcc-radio label="必现"></bcc-radio>
                <bcc-radio label="偶现"></bcc-radio>
              </bcc-radio-group>
            </bcc-form-item>
            <bcc-form-item label="复现流程" prop="recurrence_desc" required>
              <bcc-input
                v-model="form.recurrence_desc"
                type="textarea"
                placeholder="请填写复现流程"
                minlength="20"
              ></bcc-input>
            </bcc-form-item>
          </bcc-form>
        </div>
        <div class="bottom">
          <bcc-button
            type="primary"
            size="large"
            style="margin-right: 16px"
            :disabled="!(form.des.trim() && form.tag_id)"
            @click="submit($event)"
            >提交</bcc-button
          >
        </div>
      </div>
      <input
        accept=".jpg,.jpeg,.png,.txt,.log,.zip,.rar"
        ref="input"
        type="file"
        style="display: none"
        @change="onFileSelected"
      />
    </template>
    <transition name="fade">
      <div v-if="status === 2" class="success-container">
        <img src="../../assets/success-application.png" alt="" />
        <p>工单提交成功，我们将会在3个工作日内回复您</p>
        <div>
          <bcc-button
            class="re-add"
            size="max-large"
            type="primary"
            @click="reAdd"
            >继续提交</bcc-button
          >
          <bcc-button size="max-large" @click="jumpToList">查看工单</bcc-button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import StatusBar from "@/components/StatusBar";
import { login } from "@/utils/login";
import Validator from "../company-core/validateWrap";
export default {
  name: "createTicket",
  components: {
    StatusBar,
    Validator,
  },
  created() {
    this.fetchTag();
  },
  methods: {
    async fetchTag() {
      let res = await this.$api.ticket.tag();
      let types = res.map((item) => {
        return {
          label: item.name,
          value: item.id,
        };
      });
      this.types = types;
    },
    jumpToList() {
      this.$router.push({ name: "ticket" });
    },
    reAdd() {
      this.status = 1;
      this.form = {
        tag_id: "",
        des: "",
        url: "",
        mobile: "",
        email: "",
        frequency: "",
        recurrence_desc: "",
      };
    },
    handleDelete() {
      this.file = null;
      this.form.url = "";
    },
    async submit(e) {
      e.preventDefault();
      if (!(this.$store.state.userInfo && this.$store.state.userInfo.mid)) {
        login();
        return;
      }
      const { des, url, email, mobile, tag_id, frequency, recurrence_desc } =
        this.form;
      if (!/^1[3-9]\d{9}$/.test(mobile)) {
        this.$message({
          content: "请输入正确的手机号码",
          type: "exception",
          offset: 60,
          duration: 1500,
        });
        return;
      }
      if (email && !/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(email)) {
        this.$message({
          content: "请输入正确的邮箱",
          type: "exception",
          offset: 60,
          duration: 1500,
        });
        return;
      }
      const form = new FormData();
      const params = {
        system: "open-platform",
        version: "1.0",
        platform: "open-platform",
        entrance: "open-platform",
        content: JSON.stringify({
          des: des && des.trim(),
          url,
          frequency,
          email,
          mobile,
          recurrence_desc,
        }),
        mid: this.$store.state.userInfo.mid,
        tag_id,
      };
      for (let key in params) {
        form.append(key, params[key]);
      }
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.$api.ticket
            .add(form)
            .then(() => {
              this.$message({
                content: "工单提交成功",
                type: "success",
                offset: 60,
                duration: 1500,
              });
              this.status = 2;
            })
            .catch((e) => {
              this.$message({
                content: e.message,
                type: "exception",
                offset: 60,
                duration: 1500,
              });
            });
        } else {
          return false;
        }
      });
    },
    onFileSelected(e) {
      const file = e.target.files[0];
      if (file.size > 10 * 1024 * 1024) {
        this.$message({
          content: "附件体积过大，请重新上传",
          type: "exception",
          offset: 60,
          duration: 1500,
        });
        return;
      }
      this.file = file;
      this.uploadFile(file);
    },
    async uploadFile(file) {
      if (!file) return;
      return await this.$api.ticket
        .upload(file)
        .then((data) => {
          this.form.url = data.url;
        })
        .catch((e) => {
          console.error(e);
          this.$message({
            content: "文件上传失败，请重试",
            type: "exception",
            offset: 60,
            duration: 1500,
          });
        });
    },
    selectFile() {
      const input = this.$refs["input"];
      input.value = null;
      this.$refs["input"].click();
    },
  },
  data() {
    return {
      status: 1, //1填写 2成功
      file: null,
      types: [],
      rules: {
        mobile: [
          /* eslint-disable */
          {
            required: true,
            trigger: "blur",
            validator: async (rule, value, callback) => {
              if (!/^1[3-9]\d{9}$/.test(this.form.mobile)) {
                callback(new Error("手机号码填写有误"));
              } else {
                callback();
              }
            },
          },
        ],
        des: [
          {
            required: true,
            trigger: "blur",
            validator: async (rule, value, callback) => {
              if (!this.form.des) {
                return callback(new Error("请填写问题描述+新增文本"));
              }
              if (this.form.des.trim().length < 20) {
                return callback(new Error("最少20个字"));
              }
              callback();
            },
          },
        ],
        recurrence_desc: [
          {
            required: true,
            trigger: "blur",
            validator: async (rule, value, callback) => {
              if (!this.form.recurrence_desc) {
                return callback(new Error("请填写复现流程"));
              }
              if (this.form.recurrence_desc.trim().length < 20) {
                return callback(new Error("最少20个字"));
              }
              callback();
            },
          },
        ],
      },
      validator: {
        email: {
          showError: false,
          validatorList: [
            {
              func: () => {
                if (this.form.email) {
                  return /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(
                    this.form.email
                  );
                }
                return true;
              },
              error: "邮箱格式不正确",
            },
          ],
          errorStyle: {
            "margin-left": "96px",
            "margin-top": "-30px",
          },
        },
      },
      form: {
        tag_id: "",
        des: "",
        url: "",
        email: "",
        mobile: "",
        frequency: "",
        recurrence_desc: "",
      },
      topStatus: {
        text: "提示：工单提交后将会在3个工作日内回复，若问题与平台无关或信息不全则无法进行答复。",
        type: "info",
      },
    };
  },
};
</script>

<style lang="less" scoped>
.create {
  width: 872px;
  margin: 0 auto;
  padding-bottom: 40px;
  position: relative;
  .attach-container {
    display: flex;
    align-items: center;
    .tip {
      font-size: 12px;
      color: #999;
      margin-left: 24px;
    }
  }
  .file-des {
    font-size: 14px;
    margin-bottom: 6px;
    padding: 2px;
    display: flex;
    align-items: center;
    .bcc-icon-ic_delete_ {
      margin-left: 4px;
      color: #999;
      font-size: 12px;
      &:hover {
        cursor: pointer;
        color: #333;
      }
    }
  }
  .status-bar {
    padding-top: 20px;
  }
  .form-container {
    border: 1px solid #e7e7e7;
    margin-top: 20px;
    h3 {
      font-size: 24px;
      padding: 20px 26px;
    }
    .line {
      height: 1px;
      background: #e7e7e7;
      width: 100%;
    }
    .form {
      margin-top: 70px;
      padding: 0 60px;
      border-bottom: 1px solid #e7e7e7;
    }
    .bottom {
      margin: 35px 0;
      text-align: center;
    }
  }
  .bcc-input {
    width: 600px;
  }
  .bcc-input-inner.textarea {
    width: 600px;
  }
  .success-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: 120px;
    .re-add {
      margin-right: 16px;
    }
    p {
      margin-top: 34px;
      margin-bottom: 42px;
    }
  }
}

.work-order-type {
  /deep/ .bcc-form-item__content {
    position: relative;

    .new-tip {
      position: absolute;
      top: 0;
      right: -318px;
      width: 300px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #fa5a57;
    }
  }
}
</style>
